import React from "react";
import { UseFormReturn } from "react-hook-form";

import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";

import {
    CreateAndEditFestivalModalProps
} from "./models";

import { t, Trans } from "@lingui/macro";
import { ZPlayFormField } from "commons/fields";
import * as Yup from "yup";
import { withUseFormHook, } from "@sinossi/mates-react-library";
import {ContentProducerService} from "services/content-producer-service";
import {EditFestivalRequest} from "models/request/edit-festival-request";
import { CreateFestivalRequest } from "models/request";

const CreateAndEditFestivalModalSchema = Yup.object().shape({
    name: Yup.string().required(t({
        id: "caefm-name-required-msg",
        message: "È necessario inserire un nome per poter modificare il festival"
    })),
});

class CreateAndEditFestivalModal extends React.Component<CreateAndEditFestivalModalProps & UseFormReturn, {}>
{
    componentDidMount(){
        if(this.props.festival){
            this.props.setValue("name", this.props.festival.value);
        }
    }

    private getValues = () => {
        let value = this.props.getValues("name")
        if(this.props.festival){
            this.editFestival(value);
        } else {
            this.createFestival(value);
        }
    }

    private editFestival = (values: any) => {
        
        let request: EditFestivalRequest = {
            value: values
        }

        ContentProducerService.editFestival(this.props.festival!.id, request, this.props.editFestivalCallback, this.props.editFestivalErrorCallback)
    }

    private createFestival = (values: any) => {

        let request: CreateFestivalRequest = {
            value: values
        }

        ContentProducerService.createFestival(request, this.props.createFestivalCallback, this.props.createFestivalErrorCallback);
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={() => this.props.closeModal()}
                color={process.env.REACT_APP_BACKGROUND_COLOR}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>
                    {this.props.festival? <Trans id="caefm-edit-title">Modifica festival</Trans> : <Trans id="caefm-create-title">Aggiungi festival</Trans>}
                </DialogTitle>
                <form>
                    <DialogContent>
                        <Typography mt={-2}>
                            <Trans id="caefm-festival-name-label">Inserisci il nome di un festival</Trans>
                        </Typography>
                        <ZPlayFormField
                            label={t({
                                id: "caefm-name",
                                message: "Festival"
                            })}
                            name="name"
                            required={true}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button size="small" onClick={this.props.closeModal}>
                            <Trans id={"caefm-close-btn"}>
                                Annulla
                            </Trans>
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            type="button"
                            disabled={this.props.formState.isSubmitting}
                            onClick={this.getValues}>
                            {this.props.festival? <Trans id={"caefm-edit-btn"}>Modifica</Trans> : <Trans id={"caefm-create-btn"}>Aggiungi</Trans>}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}

export default withUseFormHook<{}>(CreateAndEditFestivalModal, CreateAndEditFestivalModalSchema, {});
